import React, { ReactNode } from 'react';
import {
  QueryClient,
  QueryClientProvider as ReactQueryProvider
} from '@tanstack/react-query';

interface Props {
  children: ReactNode;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

const QueryProvider: React.FC<Props> = ({ children }) => {
  return (
    <ReactQueryProvider client={queryClient}>{children}</ReactQueryProvider>
  );
};

export default QueryProvider;
